import { SMSWritebackService } from '@weave/schema-gen-ts/dist/schemas/sms/writeback/v1/writeback_service.pb';
import { bindHTTP } from '@frontend/schema';

export const SchemaWritebackV1Service = bindHTTP(SMSWritebackService);
export const serviceName = 'writeback-v1' as const;
